import { systemCode } from '../..';
import { getConfiguration } from './configuration';
import { getCurrencySymbol } from './getCurrencySymbol';
import { getPrintableAmount } from './getPrintableAmount';

export function getCurrencyValue(amount, multiplier, decimals, currency) {
	let ln = getPrintableAmount(amount, multiplier, decimals);
    currency = getCurrencySymbol(currency);
    if (getConfiguration().iwh) {
        return systemCode === 'SUREBET' ? `${currency}${ln}` : `${ln}${currency}`;
    }
    return systemCode === 'SUREBET' ?  `${currency} ${ln} ` : `${ln} ${currency}`;
}
